import Step2y2n0 from './Step2y2n0'

export default Step2y2n0